import AppProvider from "providers/AppProvider";
import ReactDOM from "react-dom/client";
import BreakpointsProvider from "providers/BreakpointsProvider";
import SettingsPanelProvider from "providers/SettingsPanelProvider";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "assets/scss/theme.scss";
import "assets/scss/addressbox-sidebar.css";
import "assets/scss/addressbox-filters.css";
import ProfileLoader from "ProfileLoader";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <AppProvider>
      <SettingsPanelProvider>
        <BreakpointsProvider>
          <ToastContainer autoClose={3000} />
          <ProfileLoader />
        </BreakpointsProvider>
      </SettingsPanelProvider>
    </AppProvider>
  </Provider>
);
